import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import "./style.scss";

const BottomNavigation = ({
  items,
  selected = null,
  onItemClick,
  noActiveBg,
  activeBgColor,
  activeTextColor,
}) => {
  const [current, setCurrent] = useState(selected);
  const orgData = useSelector((state) => state.LoginSM.orgData);

  useEffect(() => {
    setCurrent(selected);
  }, [selected]);

  function getItemStyle() {
    const style = {};
    if (noActiveBg && !activeBgColor) {
      style.backgroundColor = "transparent";
    }
    if (activeBgColor) {
      style.backgroundColor = activeBgColor;
    }
    return style;
  }

  const navItems = items.map((item, idx) => {
    return (
      <div
        key={"nav-item-" + idx}
        id={"nav-item-" + idx}
        className={`bottom-nav-item ${current === idx && "active"}`}
        style={current === idx ? getItemStyle() : {}}
        onClick={() => {
          setCurrent(idx);
          if (item.onClick) {
            item.onClick({ id: idx, ...item });
          }
          if (onItemClick) {
            onItemClick({ id: idx, ...item });
          }
        }}
      >
        {current !== idx && item.icon ? item.icon : ""}
        {current === idx && item.activeIcon ? item.activeIcon : ""}
        {item.title && (
          <p
            className="bottom-nav-item--title"
            style={
              current === idx
                ? {
                    color:
                      Object.keys(orgData).length > 0
                        ? orgData.theme_color
                        : activeTextColor,
                  }
                : {}
            }
          >
            {item.title}
          </p>
        )}
      </div>
    );
  });
  return <div className="bottom-nav col-md-6">{navItems}</div>;
};

export default BottomNavigation;
